import { Circle2d, Group2d, Polygon2d, type Geometry2d, Vec } from "./canvas";
import type { DraftingProps } from "../shared/drafting";

class WallGeometry extends Group2d {
  override getBoundsVertices() {
    if (this.excludeFromShapeBounds) return [];
    // Group2d otherwise bounds circles by their sampled outline vertices.
    return this.children.flatMap((child) => child.bounds.corners);
  }
}

/** Match the wall's round SVG stroke, including its caps and connected corners. */
export function wallGeometry(props: DraftingProps) {
  const radius = Math.max(0.1, props.thickness / 2 + props.weight);
  const children: Geometry2d[] = props.points.map(
    (point) =>
      new Circle2d({
        x: point.x - radius,
        y: point.y - radius,
        radius,
        isFilled: true,
      }),
  );
  for (let i = 1; i < props.points.length; i++) {
    const a = props.points[i - 1],
      b = props.points[i];
    const dx = b.x - a.x,
      dy = b.y - a.y;
    const length = Math.hypot(dx, dy);
    if (!length) continue;
    const nx = (-dy / length) * radius,
      ny = (dx / length) * radius;
    children.push(
      new Polygon2d({
        points: [
          new Vec(a.x + nx, a.y + ny),
          new Vec(b.x + nx, b.y + ny),
          new Vec(b.x - nx, b.y - ny),
          new Vec(a.x - nx, a.y - ny),
        ],
        isFilled: true,
      }),
    );
  }
  return new WallGeometry({ children });
}
